import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {ProjectType} from 'yougile-model'
import {Tracking, TrackingEvent} from '@common/tracking'
import {Button} from '@components/common/base/buttons'
import {useCompanyInvitePopupStore} from '@components/dashboard/company-invite-popup/company-invite-popup-store'
import {cn} from '@containers/html-utils'
import {useProjectParticipantStore} from './project-participants-store'

type ProjectParticipantsFooterProps = {
  type: ProjectType
}

export const ProjectParticipantsFooter = observer(
  ({type}: ProjectParticipantsFooterProps) => {
    const [, store] = useProjectParticipantStore()
    const [, inviteStore] = useCompanyInvitePopupStore()

    const isMainTabs = store.isUsersTab || store.isRolesTab

    return (
      <div className="flex items-center gap-12">
        <Button
          color="secondary"
          className={cn('ml-auto')}
          onClick={store.close}
          rounded={'8'}
        >
          {Lang.msg.cancel}
        </Button>

        {isMainTabs && (
          <Button
            color="primary"
            onClick={() => {
              if (type === 'crm') {
                Tracking.send(
                  TrackingEvent.crmClickOnCreateCrmProjectInPopupForm
                )
              }

              store.submit()
            }}
            rounded={'8'}
            disabled={!store.hasChanges}
          >
            {!store.props.project
              ? Lang.msg.createProject
              : Lang.msg.taskTemplates.saveButton}
          </Button>
        )}

        {store.isInviteTab && (
          <Button
            color="primary"
            rounded={'8'}
            onClick={() => {
              if (inviteStore.canSubmit()) {
                inviteStore.onSubmit()
                if (!store.props.project?.id) {
                  store.updateInvited(inviteStore.emails.map(e => e.text))
                }
                store.close()
              }
            }}
            disabled={!inviteStore.canSubmit()}
          >
            {Lang.msg.invitePopup.inviteUsersButton}
          </Button>
        )}
      </div>
    )
  }
)
